import createReactClass from "create-react-class";
import React from "react";

import { ControlLabel } from "react-bootstrap";
import { PrintSchematicActions } from "../actions/printSchematicActions";
import { SchematicAPI } from "../actions/schematicAPI";
import Constants from "../constants/constants";
import { dispatcher } from "../dispatcher/dispatcher";
import { subdivisionStore } from "../stores/subdivision";
const { ActionTypes } = Constants;

//function to get state from store, getting the currently loaded formb
function getStateFromStores() {
  return {};
}

var GisEnvView = createReactClass({
  componentDidMount: function () {},

  componentWillUnmount: function () {},

  getInitialState: function () {
    return getStateFromStores();
  },

  _onChange: function () {
    this.setState(getStateFromStores());
  },
  selectGisEnv: function (event) {
    var val = event.target.value;

    window.gritConfig.gisEnvironment = val;
    dispatcher.dispatch({
      type: ActionTypes.GIS_ENVIRONMENT_CHANGED,
    });

    $("#mainSchematic").empty();
    SchematicAPI.initialize();
    $("#printSchematic").empty();
    PrintSchematicActions.initialize();
    var selectedSub = subdivisionStore.getSelectedSub();

    //selectedSub is 0 if no sub has been selected from the drop down. so don't try to set the schematic
    if (selectedSub != 0) {
      SchematicAPI.setSubdivision(selectedSub)
        .then(function () {
          SchematicAPI.showAllLayers();
          console.log("Set subdivision for Main Schematic");

          PrintSchematicActions.setSubdivision(selectedSub)
            .then(function () {
              PrintSchematicActions.showAllLayers();
              console.log("Set subdivision for Print Schematic");
            })
            .catch(function (e) {
              console.log("Failed to set subdivision for Print Schematic: ", e);
            });
        })
        .catch(function (e) {
          console.log("Failed to set subdivision for Main Schematic: ", e);
        });
    }
  },

  render: function () {
    var environments = [];

    environments.push(
      <option key="dev" value="dev">
        DEV
      </option>
    );
    environments.push(
      <option key="trial" value="trial">
        TRIAL
      </option>
    );
    environments.push(
      <option key="prod" value="prod">
        PROD
      </option>
    );

    var environmentList = (
      <div>
        <ControlLabel style={{ color: "gray" }}>Schematic:</ControlLabel>{" "}
        <select id="gisSelect" onChange={this.selectGisEnv}>
          {environments}
        </select>
      </div>
    );

    return <div>{environmentList}</div>;
  },
});

export default GisEnvView;
